module.exports = __webpack_public_path__ + "static/sandra-rogers.ff3014f1.webp";